import ClientsApiService from '@/modules/clients/services/ClientsApiService';

export const CACHE_KEY_LIST_CLIENT_CHILD_STRUCTURES = 'client-child-structures';
export const CACHE_KEY_CLIENT_CHILD_STRUCTURES = 'client-child-structures-one';
export const ROUTE_PATH_CLIENT_CHILD_STRUCTURES = `/clients/directory-list/structures/${ClientsApiService.getStructureId()}/structure`;
export const TRANSLATION_PREFIX_CLIENT_CHILD_STRUCTURES = 'groups';
export const DIALOG_NAME_SPACE = 'substructure-dialog';
export const ESTABLISHMENT_DIALOG_NAME_SPACE = 'establishment-dialog';

